import { render, staticRenderFns } from "./q-bank-creation-page.html?vue&type=template&id=7b4dd043&scoped=true&external"
import script from "./q-bank-creation-page.js?vue&type=script&lang=js&external"
export * from "./q-bank-creation-page.js?vue&type=script&lang=js&external"
import style0 from "./q-bank-creation-page.scss?vue&type=style&index=0&id=7b4dd043&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4dd043",
  null
  
)

export default component.exports